export function getUserFacingErrorMessage(error: unknown, fallback: string): string {
    if (typeof error === "string") {
        const t = error.trim();
        return t.length > 0 ? t : fallback;
    }
    if (error instanceof Error) {
        const t = error.message.trim();
        return t.length > 0 ? t : fallback;
    }
    if (error && typeof error === "object") {
        const coded = error as { code?: unknown; message?: unknown };
        if (typeof coded.message === "string") {
            const msg = coded.message.trim();
            if (msg.length > 0) return msg;
        }
    }
    return fallback;
}

/** Log full error in dev only (avoids noisy production consoles). */
export function logErrorForDev(context: string, error: unknown): void {
    if (import.meta.env?.DEV) console.error(`[${context}]`, error);
}
